import Price from '../model/price'

export default function validatePrice(price: unknown): Price | null {
  if (typeof price !== 'object' || price === null) {
    return null
  }

  if (!('amount' in price && 'currency' in price)) {
    return null
  }

  if (typeof price.amount !== 'number' || typeof price.currency !== 'string') {
    return null
  }

  return price as Price
}
